import React from "react";
import Select from "react-select";
import { colourStyles } from "../common/scripts/react-select-styles";
import FormatoDireccion from "./sub_components/formatoDireccion";
import ModalDireccion from "../common/scripts/modalDirecciones";
import { Panel } from "react-bootstrap";
import ConsentimientoInformado from "./sub_components/consentimientoInformado";
import EtapaPriorizacion from "./sub_components/etapaPriorizacion";

export default class Vacuna extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      departamentosList: this.props.departamentosList,
      departamentoSelected: null,
      ciudadesList: [],
      ciudadSelected: null,
      showDireccion: false,
      collapseVacuna: false,
      collapseConsentimineto: false,
      collapseEtapaPriorizacion: false,
      visibleSelectorDocumento: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleCiudad = this.handleCiudad.bind(this);
    this.updateComponents = this.updateComponents.bind(this);
    this.priorizacionRef = React.createRef();
    this.actualizarDatosRef = React.createRef();
  }

  handleChange(selectedOption) {
    this.setState(
      { departamentoSelected: selectedOption, ciudadSelected: null },
      () => {
        this.props.handleInput(event, selectedOption, "Departamento");
        this.props.getDepartamentos(true, selectedOption.value);
      }
    );
  }

  handleCiudad(selectedOption) {
    this.setState({ ciudadSelected: selectedOption });
    this.props.handleInput(event, selectedOption, "Ciudad");
  }

  handleDireccionSubmit(direccion, barrio, observaciones) {
    this.props.handleDireccion(direccion, barrio, observaciones);
    this.setState({ showDireccion: false });
  }

  updateComponents() {
    this.priorizacionRef.current.click();
    this.actualizarDatosRef.current.click();
    this.setState({ collapseVacuna: true, collapseEtapaPriorizacion: false });
    // this.actualizarDatosRef.current.scrollIntoView();
    document
      .getElementById("actualizarDatosVacunaCovid")
      .scrollIntoView({ behavior: "smooth" });
    // window.scroll({
    //     top: 200,
    //     behavior: 'smooth'
    //   });
  }

  render() {
    const { departamentoSelected, ciudadSelected } = this.state;
    let props = this.props;
    let [
      nombre,
      id,
      idNum,
      fechaNacimiento,
      email,
      ciudad,
      emailIsValid,
      celular,
      telefonoFijo,
      idList,
      aceptaTC,
      direccion,
      barrio,
      localidad,
      pregunta1,
      pregunta2,
      departamento,
    ] = [
      props.nombre,
      props.documentSelected.CSDocumentoIdentidadText,
      props.numeroDocumento,
      props.fechaNacimiento,
      props.email,
      props.ciudad,
      props.emailIsValid,
      props.celular,
      props.telefonoFijo,
      props.documentos,
      props.aceptaTerminosCondiciones,
      props.direccion,
      props.barrio,
      props.localidad,
      props.pregunta1,
      props.pregunta2,
      props.departamento,
    ];

    let icon1 = this.state.collapseVacuna
      ? "fa fa-chevron-circle-up"
      : "fa fa-chevron-circle-down";
    let icon2 = this.state.collapseConsentimineto
      ? "fa fa-chevron-circle-up"
      : "fa fa-chevron-circle-down";
    let icon3 = this.state.collapseEtapaPriorizacion
      ? "fa fa-chevron-circle-up"
      : "fa fa-chevron-circle-down";
    let openPanel1 = !this.state.collapseVacuna ? "Color" : "ColorOrange";
    let openPanel2 = !this.state.collapseConsentimineto
      ? "Color"
      : "ColorOrange";
    let openPanel3 = !this.state.collapseEtapaPriorizacion
      ? "Color"
      : "ColorOrange";

    return (
      <section
        id="actualizarDatosVacunaCovid"
        className="tab-pane fade form-container formularioSolicitud mainContent"
        id="nav-vacuna"
        role="tabpanel"
        aria-labelledby="nav-vacuna-tab"
      >
        <ModalDireccion
          msg={
            <FormatoDireccion
              direccion={this.handleDireccionSubmit.bind(this)}
            />
          }
          showModal={this.state.showDireccion}
        />

        <div
          dangerouslySetInnerHTML={props.handleGenericHtml(
            i18next.t("forms.form6subtitulo")
          )}
        />

        <div className="fix-block">
          <Panel>
            <Panel.Heading>
              <Panel.Title toggle>
                <a
                  ref={this.actualizarDatosRef}
                  id="actualizarDatosVacunaCovid"
                  onChange={() =>
                    this.setState({
                      collapseVacuna: !this.state.collapseVacuna,
                    })
                  }
                >
                  <span className={openPanel1}>
                    {i18next.t("forms.vacunaSubtitulo1")}
                    <i className={"float--Right " + icon1}></i>
                  </span>
                </a>
              </Panel.Title>
            </Panel.Heading>
            <Panel.Collapse>
              <Panel.Body>
                <div className="contentCertificationCollapse">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group row">
                      <div className="col-sm-4">
                        <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                          Documento de identidad*
                        </p>
                        <p className="formularioSolicitud--text-aligned">
                          {i18next.t("forms.cedulaIndicacion")}
                        </p>
                      </div>
                      <div className="col-sm-3">
                        <button
                          disabled={false}
                          style={{ cursor: "pointer" }}
                          className="dropdown-toggle formularioSolicitud--dropDown"
                          // type="button"
                          id="dropdownCedula"
                          // data-toggle="dropdown"
                          // aria-haspopup="true"
                          // aria-expanded="true"
                          onClick={() =>
                            this.setState({
                              visibleSelectorDocumento:
                                !this.state.visibleSelectorDocumento,
                            })
                          }
                        >
                          <div>
                            <p className="text-left">{id}</p>
                          </div>
                          <span className="caret"></span>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownCedula"
                            style={{
                              cursor: "pointer",
                              display: `${
                                this.state.visibleSelectorDocumento
                                  ? "block "
                                  : "none"
                              }`,
                            }}
                          >
                            {idList.map((item, index) => {
                              return (
                                <li
                                  key={index}
                                  onClick={() => {
                                    this.setState({
                                      visibleSelectorDocumento: false,
                                    });
                                    props.updateocumentSelected(item);
                                  }}
                                >
                                  <p>{item.CSDocumentoIdentidadText}</p>
                                </li>
                              );
                            })}
                          </ul>
                        </button>
                      </div>

                      <div className="col-sm-5">
                        <input
                          style={{ cursor: "pointer" }}
                          disabled={false}
                          type="text"
                          className={
                            props.numeroDocumento == "" || props.numeroDocumento == " "
                              ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                              : "form-control formularioSolicitud--input"
                          }
                          value={props.numeroDocumento}
                          onChange={() => props.handleInput(event)}
                          onBlur={() => props.handleBlur(event)}
                          name="NumeroDocumento"
                          maxLength={33}
                        />
                        {props.numeroDocumento == "" || props.numeroDocumento == " " || props.numeroDocumento == null ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.cedulaError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.nombre")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="text"
                          className={
                            nombre == "" || nombre == " "
                              ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                              : "form-control formularioSolicitud--input"
                          }
                          value={nombre}
                          onChange={() => props.handleInput(event)}
                          onFocus={() => props.handleInput(event)}
                          name="Nombre"
                        />
                        {nombre == "" || nombre == " " || nombre == null ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.nombreError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.fechaNacimiento")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="date"
                          className={
                            fechaNacimiento == "" || fechaNacimiento == " "
                              ? "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input formularioSolicitud--input-error"
                              : "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input"
                          }
                          value={fechaNacimiento}
                          onChange={() => props.handleInput(event)}
                          onFocus={() => props.handleInput(event)}
                          name="FechaNacimiento"
                        />
                        {fechaNacimiento == "" ||
                        fechaNacimiento == " " ||
                        fechaNacimiento == null ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.errorFechaNacimiento")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.departamento")}
                      </label>
                      <div className="col-sm-8">
                        <Select
                          placeholder={"Seleccione una opción"}
                          value={departamentoSelected}
                          onChange={this.handleChange}
                          options={this.props.departamentosList}
                          styles={colourStyles}
                        />
                        {departamento == "" ||
                        departamento == " " ||
                        departamento == null ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.departamentoError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.ciudad")}
                      </label>
                      <div className="col-sm-8">
                        <Select
                          placeholder={"Seleccione una opción"}
                          value={ciudadSelected}
                          onChange={this.handleCiudad}
                          options={this.props.ciudadesList}
                          styles={colourStyles}
                          isDisabled={
                            departamentoSelected === null ? true : false
                          }
                        />
                        {ciudad == "" || ciudad == " " || ciudad == null ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.ciudadError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.direccion")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="text"
                          className={
                            direccion == "" || direccion == " "
                              ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                              : "form-control formularioSolicitud--input"
                          }
                          value={direccion}
                          // onChange={() => this.props.handleInput(event)}
                          // onFocus={() => this.setState({ showDireccion: true })}
                          onChange={() =>
                            this.setState({ showDireccion: true })
                          }
                          name="Direccion"
                        />
                        {direccion == "" ||
                        direccion == " " ||
                        direccion == null ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.direccionError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.localidad")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="text"
                          className={
                            localidad == "" || localidad == " "
                              ? "form-control formularioSolicitud--input  "
                              : "form-control formularioSolicitud--input"
                          }
                          value={localidad}
                          onChange={() => this.props.handleInput(event)}
                          onFocus={() => this.props.handleInput(event)}
                          name="Localidad"
                        />
                        {localidad == "" ||
                        localidad == " " ||
                        localidad == null ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            Digíte una localidad válida
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.telefono")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="text"
                          className={
                            celular == "" || celular == " "
                              ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                              : "form-control formularioSolicitud--input"
                          }
                          value={celular}
                          onChange={() => props.handleInput(event)}
                          name="Celular"
                          maxLength={13}
                        />
                        {celular == "" ||
                        celular == " " ||
                        celular == null ||
                        celular.length < 10 ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.telefonoError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.telefonoFijo")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="text"
                          className={
                            telefonoFijo == "" || telefonoFijo == " "
                              ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                              : "form-control formularioSolicitud--input"
                          }
                          value={telefonoFijo}
                          onChange={() => props.handleInput(event)}
                          name="TelefonoFijo"
                          maxLength={13}
                        />
                        {telefonoFijo == "" ||
                        telefonoFijo == " " ||
                        telefonoFijo == null ||
                        telefonoFijo.length < 7 ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.telefonoFijoError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.email")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="text"
                          className={
                            email == "" || email == " "
                              ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                              : "form-control formularioSolicitud--input"
                          }
                          value={email}
                          onChange={() => props.handleInput(event)}
                          onFocus={() => props.handleInput(event)}
                          name="Email"
                        />
                        {email == "" ||
                        email == " " ||
                        email == null ||
                        emailIsValid == false ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.emailError")}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.formVacunaPregunta1")}
                      </label>
                      <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                        <div className="cotizar-form-controls">
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.updateSintomas(
                                !pregunta1,
                                "formVacunaPregunta1"
                              );
                            }}
                            className={`cotizar-form-controls-action ${
                              pregunta1 ? "active" : null
                            }`}
                          >
                            Si
                          </button>
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.updateSintomas(
                                !pregunta1,
                                "formVacunaPregunta1"
                              );
                            }}
                            className={`cotizar-form-controls-action ${
                              !pregunta1 ? "active" : null
                            }`}
                          >
                            No
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.formVacunaPregunta2")}
                      </label>
                      <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                        <div className="cotizar-form-controls">
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.updateSintomas(
                                !pregunta2,
                                "formVacunaPregunta2"
                              );
                            }}
                            className={`cotizar-form-controls-action ${
                              pregunta2 ? "active" : null
                            }`}
                          >
                            Si
                          </button>
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.updateSintomas(
                                !pregunta2,
                                "formVacunaPregunta2"
                              );
                            }}
                            className={`cotizar-form-controls-action ${
                              !pregunta2 ? "active" : null
                            }`}
                          >
                            No
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="center-block" style={{ width: "400px" }}>
                        <div className="checkbox-inline center-block">
                          <div className="cotizar-form-controls btn-terminosCondiciones">
                            <button
                              onClick={(event) => {
                                event.preventDefault();
                                this.props.handleTerminosCondiciones(true);
                              }}
                              className={`cotizar-form-controls-action ${
                                aceptaTC ? "active" : null
                              }`}
                            >
                              Si
                            </button>
                            <button
                              onClick={(event) => {
                                event.preventDefault();
                                this.props.handleTerminosCondiciones(false);
                              }}
                              className={`cotizar-form-controls-action ${
                                !aceptaTC ? "active" : null
                              }`}
                            >
                              No
                            </button>
                          </div>
                          <label style={{ width: "200px" }}>
                            Autorización del tratamiento de los datos personales
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="center-block" style={{ width: "400px" }}>
                        <div className="checkbox-inline center-block">
                          <div className="cotizar-form-controls  btn-terminosCondiciones">
                            <button
                              onClick={(event) => {
                                event.preventDefault();
                                this.props.handleAceptaRecibirInformacion(true);
                              }}
                              className={`cotizar-form-controls-action ${
                                props.aceptaRecibirInformacion ? "active" : null
                              }`}
                            >
                              Si
                            </button>
                            <button
                              onClick={(event) => {
                                event.preventDefault();
                                this.props.handleAceptaRecibirInformacion(
                                  false
                                );
                              }}
                              className={`cotizar-form-controls-action ${
                                !props.aceptaRecibirInformacion
                                  ? "active"
                                  : null
                              }`}
                            >
                              No
                            </button>
                          </div>
                          <label style={{ width: "200px" }}>
                            Acepto recibir informacion de Compensar en mi correo
                            electronico, sms, whatsapp y comunicaciones fisicas
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12 text-center">
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={() => {
                            props.handlePlan("TemasCovid19-Vacuna"),
                              this.setState({
                                departamentoSelected: null,
                                ciudadSelected: null,
                              });
                          }}
                          disabled={
                            nombre == "" ||
                            nombre == " " ||
                            nombre == null ||
                            props.numeroDocumento == "" ||
                            props.numeroDocumento == " " ||
                            props.numeroDocumento == null ||
                            id == "elija un documento" ||
                            celular == "" ||
                            celular == " " ||
                            celular == null ||
                            // barrio == "" || barrio == " " || barrio == null ||
                            departamento == "" ||
                            departamento == " " ||
                            departamento == null ||
                            this.state.departamentoSelected == "" ||
                            this.state.departamentoSelected == " " ||
                            this.state.departamentoSelected == null ||
                            direccion == "" ||
                            direccion == " " ||
                            direccion == null ||
                            aceptaTC == false ||
                            ciudad == null ||
                            ciudad == "" ||
                            email == "" ||
                            email == " " ||
                            email == null ||
                            emailIsValid == false
                              ? true
                              : false
                          }
                        >
                          {i18next.t("forms.buttonVacunaSubmit")}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </Panel.Body>
            </Panel.Collapse>
          </Panel>
        </div>

        <div className="fix-block">
          <Panel>
            <Panel.Heading>
              <Panel.Title toggle>
                <a
                  onClick={() =>
                    this.setState({
                      collapseConsentimineto:
                        !this.state.collapseConsentimineto,
                    })
                  }
                >
                  <span className={openPanel2}>
                    {i18next.t("forms.vacunaSubtitulo2")}
                    <i className={"float--Right " + icon2}></i>
                  </span>
                </a>
              </Panel.Title>
            </Panel.Heading>
            <Panel.Collapse>
              <Panel.Body>
                <div className="contentCertificationCollapse">
                  <ConsentimientoInformado documentos={props.documentos} />
                </div>
              </Panel.Body>
            </Panel.Collapse>
          </Panel>

          <Panel>
            <Panel.Heading>
              <Panel.Title toggle>
                <a
                  ref={this.priorizacionRef}
                  onClick={() =>
                    this.setState({
                      collapseEtapaPriorizacion:
                        !this.state.collapseEtapaPriorizacion,
                    })
                  }
                >
                  <span className={openPanel3}>
                    {i18next.t("forms.vacunaSubtitulo3")}
                    <i className={"float--Right " + icon3}></i>
                  </span>
                </a>
              </Panel.Title>
            </Panel.Heading>
            <Panel.Collapse>
              <Panel.Body>
                <div className="contentCertificationCollapse">
                  <EtapaPriorizacion
                    numeroDocumento
                    documentos={props.documentos}
                    handleGenericHtml={props.handleGenericHtml}
                    activateRegistraDatos={() => this.updateComponents()}
                  />
                </div>
              </Panel.Body>
            </Panel.Collapse>
          </Panel>
        </div>
      </section>
    );
  }
}
